import React from "react";

import Card from "./Card";
import Button from "./Button";
import classes from "./GenericModal.module.css";

const GenericModal = (props) => {
  return (
    <div>
      <div className={classes.backdrop} onClick={props.onConfirm} />
      <Card className={classes.modal}>
        <header className={classes.header}>
          <h2>{props.title}</h2>
        </header>
        <div className={classes.content}>
          <p>{props.message}</p>
        </div>
        <footer className={classes.actions}>
          <Button onClick={props.onConfirm}>{props.buttonText}</Button>
        </footer>
      </Card>
    </div>
  );
};

const LoadingModal = (props) => {
  return (
    <div>
      <div className={classes.backdrop} onClick={props.onConfirm} />
      <Card className={classes.modal}>
        <header className={classes.header}>
          <h2 className = "text-center object-center">{props.title}</h2>
        </header>
        <div className={classes.content}>
          <p>{props.message}</p>
        </div>
      </Card>
    </div>
  );
};

export {LoadingModal, GenericModal}
